import { toast } from "react-toastify";
import { SubscriptionType } from "../type";
import { Button, Modal, Popconfirm, Tag } from "antd";
import { useState } from "react";
import EditSubcriptionsModal from "./editSubcriptionsModal";
import EditFeaturesSubscriptionsModal from "./editFeatureOfSubModal";
import deleteSubcriptions from "../function/deleteSubcriptions";

const SubscriptionDisplayItem = ({
    subscription,
    setTriggerReload,
}: {
    subscription: SubscriptionType;
    setTriggerReload: React.Dispatch<React.SetStateAction<number>>;
}) => {
    const [editModal, setEditModal] = useState(false);
    const [editFeature, setEditFeature] = useState(false);

    const handleDelete = () => {
        deleteSubcriptions(subscription.id)
            .then(res => {
                if (res) {
                    toast.success("Subscription deleted successfully");
                    setTriggerReload(prev => prev + 1);
                }
            })
            .catch(() => toast.error("Failed to delete subscription"));
    };

    return (
        <div className="bg-bg-card border border-border rounded-xl p-5 shadow-card">
            <div className="flex justify-between items-start mb-3">
                <div className="flex flex-col gap-0.5">
                    <h3 className="text-base font-semibold text-text-primary">{subscription.name}</h3>
                    <p className="text-sm text-text-secondary">{subscription.description}</p>
                    <p className="text-sm font-bold text-text-primary">${subscription.price.toFixed(2)}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    <Button size="small" onClick={() => setEditFeature(true)}>Edit Features</Button>
                    <Button size="small" type="primary" onClick={() => setEditModal(true)}>Edit</Button>
                    <Popconfirm
                        title="Delete Subscription"
                        description="Are you sure?"
                        placement="topRight"
                        onConfirm={handleDelete}
                        okText="Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true }}
                    >
                        <Button size="small" danger>Delete</Button>
                    </Popconfirm>
                </div>
            </div>

            <div className="flex flex-wrap gap-1.5">
                {subscription.features.slice(0, 10).map((f: any) => (
                    <Tag key={f.id}>{f.name}</Tag>
                ))}
                {subscription.features.length > 10 && (
                    <Tag color="blue">+{subscription.features.length - 10} more</Tag>
                )}
                {subscription.features.length === 0 && (
                    <span className="text-sm text-text-muted">No features</span>
                )}
            </div>

            <Modal
                title="Edit Features of Subscription"
                open={editFeature}
                width={1000}
                style={{ top: 20 }}
                onCancel={() => setEditFeature(false)}
                footer={null}
            >
                <EditFeaturesSubscriptionsModal
                    subcriptionId={subscription.id}
                    onClose={() => { setTriggerReload(prev => prev + 1); setEditFeature(false); }}
                />
            </Modal>

            <Modal
                title="Edit Subscription"
                open={editModal}
                width={800}
                onCancel={() => setEditModal(false)}
                footer={null}
            >
                <EditSubcriptionsModal
                    subcriptionId={subscription.id}
                    onClose={() => { setTriggerReload(prev => prev + 1); setEditModal(false); }}
                />
            </Modal>
        </div>
    );
};

export default SubscriptionDisplayItem;
